export enum NoteOperations {
    edit = "EDIT",
    remove = "REMOVE",
}
